import React from 'react';
import { useIntl } from 'react-intl';

// todo: this is just a proof on concept right now,
//  but we if we decide to move forward with it, we should
//  connect this to state and add caching on translations
export const withTranslations = (ts) => (Comp) => (props) => {
  const intl = useIntl();
  const messages = Object.keys(ts).reduce((acc, key) => {
    return {
      ...acc,
      [key]: intl.formatMessage(ts[key]),
    };
  }, {});
  return <Comp messages={messages} {...props} />;
};
